import { render } from "./CustompPublish.vue?vue&type=template&id=662e4669&scoped=true"
import script from "./CustompPublish.vue?vue&type=script&lang=js"
export * from "./CustompPublish.vue?vue&type=script&lang=js"

import "./CustompPublish.vue?vue&type=style&index=0&id=662e4669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662e4669"]])

export default __exports__